import { render, staticRenderFns } from "./ReplaceCategory.vue?vue&type=template&id=db08d970&scoped=true&"
import script from "./ReplaceCategory.vue?vue&type=script&lang=js&"
export * from "./ReplaceCategory.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceCategory.vue?vue&type=style&index=0&id=db08d970&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db08d970",
  null
  
)

export default component.exports